<script setup lang="ts">
const { showModal, changeShowModal } = useModal()

const inputModel = ref('')

const route = useRoute()

const hideModal = () => {
  changeShowModal(false)
  inputModel.value = ''
}

onMounted(() => {
  document.addEventListener('keydown', (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault()
      changeShowModal(true)
    }
    if (event.key === 'Escape') {
      hideModal()
    }
  })
})

watch(() => route.fullPath, () => {
  hideModal()
})
</script>

<template>
  <Teleport to="body">
    <div
      v-if="showModal"
      class="modalBackground"
      @click="hideModal"
    >
      <slot name="modal" />
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.modalBackground {
  //@apply fixed top-0 left-0 w-full h-full bg-black/20 backdrop-blur-sm z-[1000];

  @apply fixed top-0 left-0 w-full h-full bg-black/20 z-[8000];

  &::before {
    @apply absolute top-0 left-0 w-full h-full backdrop-blur-sm;
    content: "";
  }
}
</style>